import { message } from 'antd';
import {getNewAccessToken} from './user.js';

export const setFetchCategoriesStatus = (status) => {
    return {
        type: "SET_FETCH_CATEGORIES_STATUS",
        status
    }
}
export const setIssueCategories = (categories) => {
    return {
        type: "SET_ISSUE_CATEGORIES",
        categories
    }
}

export const fetchIssueCategories = () => {
    return dispatch => {
        dispatch(setFetchCategoriesStatus("LOADING"))
        return fetch(`https://www.api.cubits.ai/api/v1/issues/categories/`, {
            method: "GET",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            if(response.ok){
                return response.json()
            }else {
                throw new Error(response.status)
            }
        })
        .then(data => {
            dispatch(setIssueCategories(data))
            dispatch(setFetchCategoriesStatus("LOADED"))
        })
        .catch(error => {
            if(parseInt(error.message) === 401){
                return dispatch(getNewAccessToken(()=>fetchIssueCategories()))
            }else {
                dispatch(setFetchCategoriesStatus("FAILED"))
                return message.error("Something went wrong.")
            }
        })
    }
}

export const submitIssue = (formData, handleAfterFailure, handleAfterSuccess) => {
    return dispatch => {
        return fetch(`https://www.api.cubits.ai/api/v1/issues/`, {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access'),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            if(response.ok){
                return response.json()
            }else {
                throw new Error(response.status)
            }
        })
        .then(data => {
            // TODO: Add to "My Reported Issues"
            handleAfterSuccess()
        })
        .catch(error => {
            if(parseInt(error.message) === 401){
                return dispatch(getNewAccessToken(()=>submitIssue(formData, handleAfterSuccess)))
            }else {
                handleAfterFailure()
            }
        })
    }
}